import React, {useRef, useState, useEffect} from 'react';
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/hotel/placeActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import * as Yup from "yup";
import {
    error,
    INTERNATIONAL,
    REQUIRED,
    selectOption
} from "../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import {GenericButton} from "../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setLoading} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {
    FL_CATEGORY,
    FL_CODE,
    FL_STATUS,
} from "../../../components/i18n/formLabels";
import {PH_CODE} from "../../../components/i18n/placeHolders";
import Switch from "react-bootstrap-switch";
import SelectGeneric from "../../../components/select/selectGeneric";
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import SuiteControllerLangs from "./_langs";
import {roomTypeService} from "../../../jwt/_services/hotel/roomTypeService";
import {showToastCustom} from "../../../components/toast/customToast";
import {getCurrentDateForCodeField} from "../../../util/DateTools";
import Amenities from "./amenities/amenities";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import ImagePicker from "../../../components/imagePickerComponents/ImagePicker";
import {roomTypeMediaService} from "../../../jwt/_services/core/roomTypeMediaService";

const SuiteControllerForm = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { udn, app, editMode, disableInputs, domainObject} = componentState?.data;

    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [category, setCategory] = useState(domainObject?.category || null);

    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);

    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject?.id,
                uid: domainObject?.uid,
                code: (domainObject?.code || `${udn?.code}_suite_` + getCurrentDateForCodeField()).toLowerCase(), // AUTOCODE
                showOrder: domainObject?.showOrder,
                tour360: domainObject?.tour360,
                codeSynxis: domainObject?.codeSynxis,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);


    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: (domainObject?.code || `${udn?.code}_suite_` + getCurrentDateForCodeField()).toLowerCase(), // AUTOCODE
            showOrder: domainObject?.showOrder,
            tour360: domainObject?.tour360,
            codeSynxis: domainObject?.codeSynxis,
        }
    });

    const onSubmit = (data, _) => {
        if (category === null)
            return showToastCustom(error, selectOption);

        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
                ...data,
                status : status,

                udn : { id: udn?.id },
                category : { id: category },

                langs: langs,
            }
        }

        // console.log(dataRequest);
        // return;

        setLoading(true);

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, roomTypeService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, roomTypeService, dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(false, false, false);
        props.onClose();
    }

    const notImplementedAction = () => {
        console.log('sin implementar');
    }

    const refreshObject = () => genericIndexedActions.get(path, roomTypeService, domainObject?.id, app?.fbDataBase?.id);

    const getForm = () => <>
        <Row>
            <Col md="6">
                <FormGroup>
                    <Label>{ FL_CODE }</Label>
                    <Input
                        type="text"
                        name="code"
                        placeholder={ PH_CODE }
                        innerRef={register}
                        disabled={disableInputs}
                        className={(errors.code ? ' is-invalid' : '')}
                    />
                    { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                </FormGroup>
            </Col>
            <Col md="4">
                <FormGroup>
                    <Label>Codigo Synxis</Label>
                    <Input
                        type="text"
                        name="codeSynxis"
                        placeholder="Codigo en Synxis"
                        innerRef={register}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>{ FL_STATUS }</Label>
                    <br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        value={ status }
                        disabled={ disableInputs }
                        onChange={ _ => setStatus(!status) }
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label>{ FL_CATEGORY }</Label>
                    <br/>
                    <SelectGeneric
                        isDisabled={ disableInputs }
                        initialValue={ category }
                        setExternalValue={ setCategory }
                        provider={hotelCategoryProvider}
                        getAllCategories={true}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label>Tour 360ª</Label>
                    <Input
                        type="text"
                        name="tour360"
                        placeholder="Ingrese codigo de tour 360ª"
                        innerRef={register}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <SuiteControllerLangs langs={langs} setLangs={setLangs} translatableLangs={domainObject?.translatedLangs || []} />
                </CardBody>
            </Col>
        </Row>
    </>


    return <>

            <Card className={'card-modal-big'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <ModalFormTitle
                        domainObject={domainObject}
                        editMode={editMode}
                        udn={udn}
                    />

                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                            onClick={handleSubmit(onSubmit)}
                        />
                        {
                            editMode &&
                            <>
                                <Separator/>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={roomTypeService} />
                                <GenericButton
                                    style={'danger-secondary'}
                                    toolTip={TT_DELETE}
                                    icon={'fa-trash'}
                                    permission={'delete'}
                                    onClick={notImplementedAction}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                { getForm() }
                            </Form>
                        </Col>

                        {
                            editMode && <Col>
                                <ImagePicker
                                    className={'roomType'}
                                    title={'Media'}
                                    app={app}
                                    service={roomTypeService}
                                    baseMediaService={roomTypeMediaService}
                                    objectMedia={domainObject}
                                    afterUpload={refreshObject}
                                />
                                <Amenities path={path} />
                            </Col>
                        }

                    </Row>
                </CardBody>
            </Card>

        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(SuiteControllerForm)